import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { NotFoundError } from 'src/shared/error';

import type { PetitionSettingsPageData } from '../types';

import type {
	PetitionSettingsV2RootPageDataQuery,
	PetitionSettingsV2RootPageDataQueryVariables,
} from './petitionSettingsRootPageData.graphql';
import { PetitionSettingsV2RootPageData } from './petitionSettingsRootPageData.graphql';

type PetitionSettingsPageDataParams = { slugOrId: string };

export async function getPetitionSettingsPageData(
	{ gql: { fetch } }: UtilityContext,
	{ slugOrId }: PetitionSettingsPageDataParams,
): Promise<PetitionSettingsPageData> {
	const { data } = await fetch<PetitionSettingsV2RootPageDataQuery, PetitionSettingsV2RootPageDataQueryVariables>({
		query: PetitionSettingsV2RootPageData,
		variables: { slugOrId },
		rejectOnError: true,
	});

	if (!data.petition) {
		throw new NotFoundError();
	}

	return { petition: data.petition };
}
